import React from 'react';
import { withRouter } from 'react-router';

import Config from '../Config';

const config = new Config();

const CryptoFooter = () => (
  <section className="form-content-section-primary flow-text" id="crypto-footer">
    <div className="container">
      <div className="row">
        <div className="col col-md-12 col-lg-10 col-lg-offset-1 footer-text">
          <b>
            TradeStation Securities, Inc.
          </b> and&nbsp;
          <b>TradeStation Technologies, Inc.
          </b> are each wholly owned subsidiaries of <b>TradeStation Group, Inc.</b>,
          both operating, and providing products and services, under the TradeStation brand and trademark.&nbsp;
          <b className="italic">
            When applying for, or
            purchasing, accounts, subscriptions, products and services, it is important that
            you know which company you will be dealing with.
          </b>
          <b>&nbsp;
            <a
              className="btn btn-info slimh_element fitv_element slimv_element reset_capitals"
              tabIndex="-1"
              href="https://uploads.tradestation.com/uploads/tradestation-group-inc-companies.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here
            </a>
          &nbsp;for further important information explaining what this means.</b>
        </div>
      </div>
    </div>
  </section>
);

const TseuFooter = () => (
  <section className="form-content-section-primary flow-text" id="crypto-footer">
    <div className="container">
      <div className="row">
        <div className="col col-md-12 col-lg-10 col-lg-offset-1 footer-text">
          For US and non-European residents, securities and futures trading is offered to
          self-directed customers by <strong>TradeStation Securities, Inc.</strong>, a
          United States broker-dealer registered with the Securities and Exchange
          Commission and a futures commission merchant licensed with the Commodity
          Futures Trading Commission. <strong>TradeStation Securities</strong> is a
          member of the Financial Industry Regulatory Authority, the National Futures
          Association, and a number of exchanges. For European residents, securities,
          options, and futures trading is offered by&nbsp;
          <strong>TradeStation Europe B.V.</strong>, which is registered with the Dutch
          Chamber of Commerce (no. 89426657) and regulated by the Dutch Authority for
          the Financial Markets in the Netherlands.
          <br />
          <br />
          <strong>TradeStation Securities, Inc.</strong>,&nbsp;
          <strong>TradeStation Europe B.V.</strong>, and&nbsp;
          <strong>TradeStation Technologies, Inc.</strong> are wholly owned subsidiaries
          of <strong>TradeStation Group, Inc.</strong>, operating, and providing products
          and services, under the TradeStation brand and trademark.&nbsp;
          <strong>
            <em>
              When applying for, or purchasing, accounts, subscriptions, products and
              services, it is important that you know which company you will be dealing
              with.&nbsp;
            </em>
            <a
              className="btn btn-info slimh_element fitv_element slimv_element reset_capitals"
              tabIndex="-1"
              href="http://www.tradestation.com/DisclosureTSCompanies"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here
            </a>
            &nbsp;for further important information explaining what this means.
          </strong>
        </div>
      </div>
    </div>
  </section>
);

const Footer = (location) => {
  const pathname = location && location.location && location.location.pathname ? location.location.pathname : '';

  const checkPage = () => {
    const isIntroPage = window.location.pathname === '/intro';
    const isInlineFundingPage = window.location.pathname === '/funding';
    const isThankYouPage = window.location.pathname === '/thank-you';

    if (isIntroPage || isInlineFundingPage || isThankYouPage) {
      return false;
    }
    return true;
  };

  return (
    <section className="bottom-footer-section" id="bottom-footer-section">
      {(checkPage()) &&
        <div className="navbar fitv_element">
          <div className="container">
            <div className="navbar-header">
              <span className="navbar-brand centered">
                <b>Need assistance?</b> &nbsp;
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.tradestation.com/contact-us/"
                >
                  Contact us.
                </a>
              </span>
            </div>
          </div>
        </div>
      }
      {pathname === '/intro' && config.tseuChangesEnabled &&
        <TseuFooter />
      }
      {pathname === '/intro' && !config.tseuChangesEnabled &&
        <CryptoFooter />
      }
    </section>
  );
};

export default withRouter(Footer);
